module.exports = __webpack_public_path__ + "static/media/eyescanvid.3772345c.mov";